import { GET, GET_BASE } from '@/api';

const URL_FACETS = '/recipe/rms_facets';
const URL_RESULTS = '/recipes/seeall/results';

export const paginationResults = async ({
  nextPage,
  hasLoadMore,
  query,
  successCB,
  failCB,
}) => {
  try {
    const { data: html } = await GET_BASE(
      `${URL_RESULTS}?q=${query}&page=${nextPage}&hasLoadMore=${hasLoadMore}`,
    );

    return (typeof successCB === 'function' && successCB(html)) || html;
  } catch (e) {
    return (typeof failCB === 'function' && failCB(e)) || e;
  }
};

export default async ({ query, hasLoadMore, config, successCB, failCB }) => {
  try {
    const currSearch = query;
    const { data: filters } = await GET(
      `${URL_FACETS}?q=${currSearch}`,
      config,
    );

    const { data: html } = await GET_BASE(
      `${URL_RESULTS}?q=${currSearch}&hasLoadMore=${hasLoadMore}`,
      config,
    );
    return (
      (typeof successCB === 'function' && successCB({ filters, html })) || {
        filters,
        html,
      }
    );
  } catch (e) {
    return (typeof failCB === 'function' && failCB(e)) || e;
  }
};
